import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { QUESTION_TYPE } from '../../../../shared/utils/constants';
import SummaryDescriptiveAnswer from './SummaryDescriptiveAnswer';
import SummaryObjectiveAnswer from './SummaryObjectiveAnswer';
import SummarySelectionAnswer from './SummarySelectionAnswer';
import SummaryBooleanAnswer from './SummaryBooleanAnswer';

const SummaryCharts = ({ summary }) => {
  return summary.map((item) => {
    switch (item.question.type) {
      case QUESTION_TYPE.DESCRIPTIVE:
        return <SummaryDescriptiveAnswer key={item.id} answer={item} />;
      case QUESTION_TYPE.OBJECTIVE:
        return <SummaryObjectiveAnswer key={item.id} answer={item} />;
      case QUESTION_TYPE.SELECTION:
        return <SummarySelectionAnswer key={item.id} answer={item} />;
      case QUESTION_TYPE.TRUE_FALSE:
        return <SummaryBooleanAnswer key={item.id} answer={item} />;
      default:
        return <></>;
    }
  });
};

SummaryCharts.propTypes = {
  summary: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.shape({
        description: PropTypes.string,
        id: PropTypes.number,
        type: PropTypes.string,
        numberOfAnswer: PropTypes.number,
      }),
      chartData: PropTypes.arrayOf(
        PropTypes.shape({
          descritiveAnswer: PropTypes.string,
          falseQuantity: PropTypes.number,
          label: PropTypes.string,
          responsible: PropTypes.shape({
            fullName: PropTypes.string,
          }),
          trueQuantity: PropTypes.number,
          value: PropTypes.number,
        })
      ),
    })
  ).isRequired,
};

export default memo(SummaryCharts);
